$(document).ready(function(){
  //show/hide backordered qty based on current stock on cart
  $('.tt-input-counter').find('input').change(function(){
      var selected_qty = $(this).val();
      var parent = $(this).parents('tr');
      var available_qty = parent.find('.tt-backorder_qua').data('current-qty');

      if(selected_qty > available_qty){
        parent.find('.tt-backorder_qua').html('* Qty: '+(selected_qty - (available_qty >= 0 ? available_qty : 0) )+' is Backordered');
      }else{
        parent.find('.tt-backorder_qua').html('');
      }
  });

  function enableFocusToggle(options = {}) {
    const {
      selector,
      focusClass,
      blurOnEscape = true
    } = options;

    const focusSelectors = document.querySelectorAll(selector);

    function handleFocus() {
      document.body.classList.add(focusClass);
    }

    function handleBlur() {
      document.body.classList.remove(focusClass);
    }

    focusSelectors.forEach(input => {
      input.addEventListener('focus', handleFocus);
      input.addEventListener('blur', handleBlur);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.body.classList.remove(focusClass);
        if (blurOnEscape) {
          const focusedInput = document.querySelector(`${selector}:focus`);
          if (focusedInput) {
            focusedInput.blur();
          }
        }
      }
    });
  }

  enableFocusToggle({
    selector: 'input.tt-search-input',
    focusClass: 'search-focused',
    blurOnEscape: true
  });

  // enableFocusToggle({
  //   selector: '.tt-cart button',
  //   focusClass: 'cart-focused',
  //   blurOnEscape: true
  // });

  function enableVisibilityToggle({ selector, activeClass, bodyClass }) {
    const target = document.querySelector(selector);
    if (!target) return;

    // Initial check in case it's already active
    if (target.classList.contains(activeClass)) {
      document.body.classList.add(bodyClass);
    }

    // Observe class changes
    const observer = new MutationObserver(() => {
      if (target.classList.contains(activeClass)) {
        document.body.classList.add(bodyClass);
      } else {
        document.body.classList.remove(bodyClass);
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Example usage
  enableVisibilityToggle({
    selector: '.tt-cart.tt-dropdown-obj',
    activeClass: 'active',
    bodyClass: 'cart-focused'
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.mm-dropdown > a.toggle-submenu');

    // Only act if clicked inside a .mm-dropdown anchor
    if (trigger) {
      e.preventDefault();

      const dropdown = trigger.parentElement;
      const submenu = dropdown.querySelector('ul');

      if (submenu) {
        // Toggle current dropdown
        dropdown.classList.toggle('open');

        // Optional: close others (accordion effect)
        document.querySelectorAll('.mm-dropdown.open').forEach(other => {
          if (other !== dropdown) other.classList.remove('open');
        });
      }
    }
  });


});